// extracted by mini-css-extract-plugin
module.exports = {"container":"MicroCard_container__BxlWG","micro":"MicroCard_micro__rJ431"};